import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectBasicState = (state: RootState) => state.Basic || initialState

export const basicSelector = createSelector([selectBasicState], Basic => Basic)
